<h2 mat-dialog-title *ngIf="!!title" [innerHTML]="title"></h2>
<mat-dialog-content [innerHTML]="content"></mat-dialog-content>
<div mat-dialog-actions class="justify-content-center align-items-center">
  <button class="{{btnConfirmClass}} me-3" [mat-dialog-close]="shouldReturn ? true : undefined">{{btnConfirm}}</button>
  <button *ngIf="shouldReturn" [class]="btnCancelClass" mat-dialog-close cdkFocusInitial>{{btnCancel}}</button>
</div>
